import React from "react";
import CarbonCalculatorPage from "@components/Pages/CarbonCalculatorPage/CarbonCalculatorPage";

export default function Kolefnisreiknir() {
    return <CarbonCalculatorPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../locales/${locale}.json`)).default,
        },
    };
}
